
const loggerMiddleware = (store: any) => (next: any) => (action: any) => {
    // Used for debugging
    // console.log('Dispatching:', action);
    return next(action);
  };
  
  export default loggerMiddleware;